import { InvoiceBase } from '../../types/Invoice';

export interface Props {
  onSubmit?: (values: Values) => void;
  initialValues?: Values;
  onBack?: () => void;
  header?: string;
  document?: InvoiceBase;
  isPrint?: boolean;
}

export interface Values {
  id?: number;
  header: string;
  body: string;
  accountingDocumentId?: string;
}

export enum ObjectType {
  SPREADSHEET = 'spreadsheet',
  TEXTAREA = 'textarea',
}
export interface DocObject {
  id: number;
  type: ObjectType;
  spreadsheetData?: any;
  textData?: any;
  className?: string;
}
